var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo, useContext, useState } from "react";
import { vaultManager, } from "braintree-web";
import { getClientToken, createPayment } from "../services";
import { Result } from "../components/Result";
import { CartInformationInitial, } from "../types";
import { makeTransactionSaleRequest } from "../services/makeTransactionSaleRequest";
import { useNotifications } from "./useNotifications";
import { useLoader } from "./useLoader";
import { setLocalPaymentIdRequest } from "../services/setLocalPaymentId";
import { makeVaultRequest } from "../services/makeVaultRequest";
var PaymentInfoInitialObject = {
    version: 0,
    id: "",
    amount: 0,
    currency: "",
    lineItems: [],
    shippingMethod: {},
    cartInformation: CartInformationInitial,
};
var PaymentContext = createContext({
    gettingClientToken: false,
    clientToken: "",
    handleGetClientToken: function () { },
    setLocalPaymentId: function () { return new Promise(function () { return 0; }); },
    handlePurchase: function () { },
    handlePureVault: function () { },
    paymentInfo: PaymentInfoInitialObject,
    vaultedPaymentMethods: [],
    handleGetVaultedPaymentMethods: function () {
        return new Promise(function (resolve) { return []; });
    },
    braintreeCustomerId: "",
    requestHeader: {},
});
export var PaymentProvider = function (_a) {
    var createPaymentUrl = _a.createPaymentUrl, createPaymentForVault = _a.createPaymentForVault, getClientTokenUrl = _a.getClientTokenUrl, purchaseUrl = _a.purchaseUrl, vaultPaymentMethodUrl = _a.vaultPaymentMethodUrl, purchaseCallback = _a.purchaseCallback, children = _a.children, cartInformation = _a.cartInformation, taxAmount = _a.taxAmount, shippingAmount = _a.shippingAmount, discountAmount = _a.discountAmount, shippingMethodId = _a.shippingMethodId, requestHeader = _a.requestHeader;
    var _b = useState(false), gettingClientToken = _b[0], setGettingClientToken = _b[1];
    var _c = useState(false), showResult = _c[0], setShowResult = _c[1];
    var _d = useState(), resultSuccess = _d[0], setResultSuccess = _d[1];
    var _e = useState(), resultMessage = _e[0], setResultMessage = _e[1];
    var _f = useState(""), clientToken = _f[0], setClientToken = _f[1];
    var _g = useState(""), braintreeCustomerId = _g[0], setBraintreeCustomerId = _g[1];
    var _h = useState(), customerVersion = _h[0], setCustomerVersion = _h[1];
    var _j = useState(PaymentInfoInitialObject), paymentInfo = _j[0], setPaymentInfo = _j[1];
    var _k = useState([]), vaultedPaymentMethods = _k[0], setVaultedPaymentMethods = _k[1];
    var notify = useNotifications().notify;
    var isLoading = useLoader().isLoading;
    var value = useMemo(function () {
        var handleGetClientToken = function (merchantAccountId, vaultPayment) { return __awaiter(void 0, void 0, void 0, function () {
            var createPaymentEndpoint, createPaymentResult, clientTokenresult, amountPlanned, lineItems, shippingMethod, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setGettingClientToken(true);
                        isLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        createPaymentEndpoint = vaultPayment && createPaymentForVault
                            ? createPaymentForVault
                            : createPaymentUrl;
                        return [4 /*yield*/, createPayment(requestHeader, createPaymentEndpoint, cartInformation, shippingMethodId)];
                    case 2:
                        createPaymentResult = (_a.sent());
                        if (!createPaymentResult.braintreeCustomerId && vaultPayment) {
                            isLoading(false);
                            setGettingClientToken(false);
                            notify("Error", "User not found");
                            return [2 /*return*/];
                        }
                        setCustomerVersion(createPaymentResult.customerVersion);
                        setBraintreeCustomerId(createPaymentResult.braintreeCustomerId);
                        if (!(createPaymentResult &&
                            createPaymentResult.id &&
                            createPaymentResult.version)) return [3 /*break*/, 4];
                        return [4 /*yield*/, getClientToken(requestHeader, getClientTokenUrl, createPaymentResult.id, createPaymentResult.version, createPaymentResult.braintreeCustomerId, merchantAccountId)];
                    case 3:
                        clientTokenresult = (_a.sent());
                        if (!clientTokenresult) {
                            isLoading(false);
                            setGettingClientToken(false);
                            notify("Error", "There is an error in getting client token!");
                            return [2 /*return*/];
                        }
                        amountPlanned = createPaymentResult.amountPlanned, lineItems = createPaymentResult.lineItems, shippingMethod = createPaymentResult.shippingMethod;
                        setPaymentInfo({
                            id: createPaymentResult.id,
                            version: clientTokenresult.paymentVersion,
                            amount: amountPlanned.centAmount / 100,
                            currency: amountPlanned.currencyCode,
                            lineItems: lineItems,
                            shippingMethod: shippingMethod,
                            cartInformation: cartInformation,
                        });
                        if (clientTokenresult.clientToken) {
                            setClientToken(clientTokenresult.clientToken);
                            setGettingClientToken(false);
                            isLoading(false);
                            return [2 /*return*/];
                        }
                        _a.label = 4;
                    case 4:
                        notify("Error", "There is an error in getting client token!");
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        notify("Error", "Authentication Error!");
                        console.error(error_1);
                        return [3 /*break*/, 6];
                    case 6:
                        setGettingClientToken(false);
                        isLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        var handleGetVaultedPaymentMethods = function () {
            if (!clientToken || vaultedPaymentMethods.length)
                return new Promise(function () {
                    return vaultedPaymentMethods;
                });
            isLoading(true);
            return vaultManager.create({ authorization: clientToken }).then(function (vaultInstance) {
                if (vaultInstance === undefined) {
                    notify("Info", "No vault manager");
                    isLoading(false);
                    return vaultedPaymentMethods;
                }
                return vaultInstance.fetchPaymentMethods({ defaultFirst: true }).then(function (customerPaymentMethods) {
                    isLoading(false);
                    if (customerPaymentMethods !== undefined) {
                        setVaultedPaymentMethods(customerPaymentMethods);
                        return customerPaymentMethods;
                    }
                    return vaultedPaymentMethods;
                }, function () {
                    return vaultedPaymentMethods;
                });
            }, function () {
                return vaultedPaymentMethods;
            });
        };
        var setLocalPaymentId = function (localPaymentId, saveLocalPaymentUrl) { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, setLocalPaymentIdRequest(requestHeader, saveLocalPaymentUrl, paymentInfo.id, paymentInfo.version, localPaymentId)];
                    case 1:
                        response = (_a.sent());
                        setPaymentInfo(__assign(__assign({}, paymentInfo), { version: response.paymentVersion }));
                        return [2 /*return*/, response.paymentVersion];
                }
            });
        }); };
        var handlePurchase = function (paymentNonce, options, overridePaymentVersion) { return __awaiter(void 0, void 0, void 0, function () {
            var additional, requestBody, response, _a, message, success;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        additional = options !== null && options !== void 0 ? options : {};
                        if (taxAmount) {
                            additional.taxAmount = taxAmount;
                        }
                        if (shippingAmount) {
                            additional.shippingAmount = shippingAmount;
                        }
                        if (discountAmount) {
                            additional.discountAmount = discountAmount;
                        }
                        requestBody = __assign({ paymentVersion: overridePaymentVersion || paymentInfo.version, paymentId: paymentInfo.id, paymentMethodNonce: paymentNonce }, additional);
                        isLoading(true);
                        return [4 /*yield*/, makeTransactionSaleRequest(requestHeader, purchaseUrl, requestBody)];
                    case 1:
                        response = (_c.sent());
                        isLoading(false);
                        if (response.ok === false || !response) {
                            notify("Error", (_b = response.message) !== null && _b !== void 0 ? _b : "An error occurred");
                            return [2 /*return*/];
                        }
                        _a = response.result.transactionSaleResponse, message = _a.message, success = _a.success;
                        setResultSuccess(success);
                        setResultMessage(message);
                        setShowResult(true);
                        if (purchaseCallback && success !== false) {
                            options === null || options === void 0 ? true : delete options.deviceData;
                            purchaseCallback(response, options);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var handlePureVault = function (paymentNonce) { return __awaiter(void 0, void 0, void 0, function () {
            var requestBody, response;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestBody = {
                            customerVersion: customerVersion,
                            customerId: braintreeCustomerId,
                            paymentMethodNonce: paymentNonce,
                        };
                        if (!vaultPaymentMethodUrl)
                            return [2 /*return*/];
                        isLoading(true);
                        return [4 /*yield*/, makeVaultRequest(requestHeader, vaultPaymentMethodUrl, requestBody)];
                    case 1:
                        response = _b.sent();
                        isLoading(false);
                        if (response.ok === false || !response) {
                            notify("Error", (_a = response.message) !== null && _a !== void 0 ? _a : "An error occurred");
                            return [2 /*return*/];
                        }
                        setResultMessage("Payment vaulted");
                        setShowResult(true);
                        if (purchaseCallback) {
                            purchaseCallback(response);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return {
            gettingClientToken: gettingClientToken,
            clientToken: clientToken,
            handleGetClientToken: handleGetClientToken,
            setLocalPaymentId: setLocalPaymentId,
            handlePurchase: handlePurchase,
            handlePureVault: handlePureVault,
            paymentInfo: paymentInfo,
            vaultedPaymentMethods: vaultedPaymentMethods,
            handleGetVaultedPaymentMethods: handleGetVaultedPaymentMethods,
            braintreeCustomerId: braintreeCustomerId,
            requestHeader: requestHeader,
        };
    }, [clientToken, gettingClientToken]);
    return (_jsx(PaymentContext.Provider, __assign({ value: value }, { children: showResult ? (_jsx(Result, { success: resultSuccess, message: resultMessage })) : (children) })));
};
export var usePayment = function () { return useContext(PaymentContext); };
